/**
 * 
 * ST Custom Filters
 *  
 * */ 

const selectors = {
    defaultStock: '.js-st-default-stock',
    inStock: '.js-st-in-stock',
    outOfStock: '.js-st-out-of-stock',
    btnInStockShow: '.js-st-instock-show',
    btnInStockHide: '.js-st-instock-hide',
    btnOosStockShow: '.js-st-oos-show',
    btnOosStockHide: '.js-st-oos-hide',
    activeInStockFilter: '.js-st-instock-filter',
    activeOosFilter: '.js-st-oos-filter',
    filters: '.js-st-filters',
    pagination: '.js-st-pagination',
    collectionJSON: "[data-collection-data-json]",
    inStockCount: ".js-st-instock-count",
    ooSCount: ".js-st-oos-count",
    defFilterCount: ".js-default-count",
    insFilterCount: ".js-ins-vendor-count",
    oosFilterCount: ".js-oos-vendor-count"
}

const classes = {
    hide: 'st__hide',
    btnInStockShow: 'js-st-instock-show',
    btnInStockHide: 'js-st-instock-hide'
}

const handle = getCollectionData().handle.trim()

const clickedFilters = []
const inStockTag = 'instock'
const outOfStockTag = 'outofstock'

const inStockCookie = `st-ins_${handle}`
const oosStockCookie = `st-oos_${handle}`

const getInStockCookie = getCookie(inStockCookie);
const getOosStockCookie = getCookie(oosStockCookie);

// Storefront API Settings
const domain = window.location.origin
this.apiURL = `${domain}/api/2024-01/graphql.json`
this.apiToken = "8fcb759f7198b8b9c3920f876af223fc"

// Count Settings
const inStockCountEl = document.querySelectorAll(selectors.inStockCount)
const ooSStockCountEl = document.querySelectorAll(selectors.ooSCount)

const pagination = document.querySelector(selectors.pagination)
const paginationNum = getCollectionData().paginate_by
const collectionNum = getCollectionData().default_products_count
const inStockCount = getCollectionData().in_stock_count
const oosStockCount = getCollectionData().oos_count

// InStock and OOS count Data
const defaultFilterCounts = document.querySelectorAll(selectors.defFilterCount)
const instockFilterCounts = document.querySelectorAll(selectors.insFilterCount)
const oosFilterCounts = document.querySelectorAll(selectors.oosFilterCount)

/**
 * 
 * ST Custom Filters - Count
 *  
 * */ 

let cursor
let inStockNumber = []
let outOfStockNumber = []
let totalInStock, totalOutOfStock
const productsQueryNum = 250

const totalIterations = Math.ceil(getCollectionData().totalProducts / productsQueryNum)

const firstPageQuery = `{
    collectionByHandle(handle: "${handle}") {
      products(first: ${productsQueryNum}) {
        pageInfo {
          hasNextPage
        }
        edges {
          node {
            totalInventory
            vendor
          }
          cursor
        }
      }
    }
}`

const otherPagesQuery = (cursor) => {
    return `{
        collectionByHandle(handle: "${handle}") {
          products(
            first: ${productsQueryNum}
            after: "${cursor}"
          ) {
            edges {
              node {
                totalInventory
                vendor
              }
              cursor
            }
          }
        }
    }`
}


const getProductsData = (query) => {
    return fetch(this.apiURL, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          "Access-Control-Origin": "*",
          'X-Shopify-Storefront-Access-Token': this.apiToken
      },
      "body": JSON.stringify({query})
      })
}

const productsCounter = (products) => {
    const inStockProducts = products.filter(product => {
        return product.node.totalInventory > 0
    })

    if (inStockProducts !== undefined) {
        inStockNumber.push(inStockProducts.length)
    }

    const outOfStockProducts = products.filter(product => {
        return product.node.totalInventory < 1
    })

    if (outOfStockProducts !== undefined) {
        outOfStockNumber.push(outOfStockProducts.length)
    }
}

const vendorsCounter = (products) => {
    const data = products
      
    const groupByVendor = (data, filterFn) =>
    data
        .filter(filterFn)
        .reduce((acc, item) => {
        const { vendor } = item.node;
        acc[vendor] = (acc[vendor] || 0) + 1;
        return acc;
        }, {});
      
    const inStockGroup = groupByVendor(data, (item) => item.node.totalInventory > 0);
    const ooStockGroup = groupByVendor(data, (item) => item.node.totalInventory < 1);
    
    // Update InStock Filter Counts
    instockFilterCounts.forEach(count => {
        const label = count.dataset.label
        let number = inStockGroup[label]

        if (number === undefined) {
            number = 0
        }

        count.textContent = `(${number})`
    });

    // Update OOS Filter Counts
    oosFilterCounts.forEach(count => {
        const label = count.dataset.label
        let number = ooStockGroup[label]

        if (number === undefined) {
            number = 0
        }

        count.textContent = `(${number})`
    });
       
}

async function getCount() {
    try {
        let cursor

        for (let index = 0; index < totalIterations; index++) {
            if (index === 0) {
                let response = await getProductsData(firstPageQuery)
                let details = await response.json()
                
                const products = details.data.collectionByHandle.products.edges
                cursor = products[products.length - 1].cursor

                productsCounter(products)
                vendorsCounter(products)
                
            } else {
                let response = await getProductsData(otherPagesQuery(cursor))
                let details = await response.json()
                const products = details.data.collectionByHandle.products.edges
                cursor = products[products.length - 1].cursor

                productsCounter(products)
                vendorsCounter(products)
            }
        }


        
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

getCount()
.then(() =>{
    totalInStock = inStockNumber.reduce((a,c) => {
        return a + c
    }, 0)

    totalOutOfStock = outOfStockNumber.reduce((a,c) => {
        return a + c
    }, 0)

    inStockCountEl.forEach(element => {
        element.textContent = `(${totalInStock})`
    });

    ooSStockCountEl.forEach(element => {
        element.textContent = `(${totalOutOfStock})`
    });
})

/**
 * 
 * ST Custom Filters - Actions
 *  
 * */ 

// Cache - Memoization
const showInStockButtons = document.querySelectorAll(selectors.btnInStockShow)
const hideInStockButtons = document.querySelectorAll(selectors.btnInStockHide)

const showOosStockButtons = document.querySelectorAll(selectors.btnOosStockShow)
const hideOosStockButtons = document.querySelectorAll(selectors.btnOosStockHide)

const defaultStock = document.querySelector(selectors.defaultStock)
const inStock = document.querySelector(selectors.inStock)
const ooStock = document.querySelector(selectors.outOfStock)

const filterWrappers = document.querySelectorAll(selectors.filters)
const activeInStockFilters = document.querySelectorAll(selectors.activeInStockFilter)
const activeOosFilters = document.querySelectorAll(selectors.activeOosFilter)

// Event Actions

// InStock Products

const showInStockProductsFilters = () => {
    // Hide Default Products
    if (defaultStock.classList.contains(classes.hide) === false) {
        defaultStock.classList.add(classes.hide)
    }

    // Hide - Show InStock Buttons
    showInStockButtons.forEach(button => {
        const parent = button.parentElement
        if (parent.classList.contains(classes.hide) === false) {
            parent.classList.add(classes.hide)
        }
    });

    // Show In Stock Products
    if (inStock.classList.contains(classes.hide)) {
        inStock.classList.remove(classes.hide)
    }

    // Show - Hide InStock Buttons
    hideInStockButtons.forEach(button => {
        const parent = button.parentElement
        if (parent.classList.contains(classes.hide)) {
            parent.classList.remove(classes.hide)
        }
    });

    // Show active instock filters
    activeInStockFilters.forEach(filter => {
        const parent = filter.parentElement
        if (parent.classList.contains(classes.hide)) {
            parent.classList.remove(classes.hide)
        }

        if (filter.classList.contains(classes.hide)) {
            filter.classList.remove(classes.hide)
        }
    });

    filterWrappers.forEach(wrapper => {
        if (wrapper.classList.contains(classes.hide)) {
            wrapper.classList.remove(classes.hide)
        }
    });

    // Show InStock Filter Counts and Hide Vendor Counts
    defaultFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide) === false) {
            count.classList.add(classes.hide)
        }
    });

    instockFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide)) {
            count.classList.remove(classes.hide)
        }
    });
}

const hideInstockProductFilters = () => {
    // Show Default Products
    if (defaultStock.classList.contains(classes.hide)) {
        defaultStock.classList.remove(classes.hide)
    }

    // Show - Show InStock Buttons
    showInStockButtons.forEach(button => {
        const parent = button.parentElement
        if (parent.classList.contains(classes.hide)) {
            parent.classList.remove(classes.hide)
        }
    });

    // Hide In Stock Products
    if (inStock.classList.contains(classes.hide) === false) {
        inStock.classList.add(classes.hide)
    }

    // Hide - Hide InStock Buttons
    hideInStockButtons.forEach(button => {
        const parent = button.parentElement
        if (parent.classList.contains(classes.hide) === false) {
            parent.classList.add(classes.hide)
        }
    });

    // Hide active InStock filters
    activeInStockFilters.forEach(filter => {
        const parent = filter.parentElement
        if (parent.classList.contains(classes.hide) === false) {
            parent.classList.add(classes.hide)
        }

        if (filter.classList.contains(classes.hide) === false) {
            filter.classList.add(classes.hide)
        }
    });

    filterWrappers.forEach(wrapper => {
        if (wrapper.classList.contains(classes.hide) === false) {
            wrapper.classList.add(classes.hide)
        }
    });

    // Show Vendor Counts and hide InStock Filters Counts
    defaultFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide)) {
            count.classList.remove(classes.hide)
        }
    });

    instockFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide) === false) {
            count.classList.add(classes.hide)
        }
    });
}

// Out Of Stock Products
const showOutOfStockProductsFilters = () => {
    // Hide Default Products
    if (defaultStock.classList.contains(classes.hide) === false) {
        defaultStock.classList.add(classes.hide)
    }

    // Hide - Show OOS Buttons
    showOosStockButtons.forEach(button => {
        const parent = button.parentElement
        if (parent.classList.contains(classes.hide) === false) {
            parent.classList.add(classes.hide)
        }
    });

    // Show OOS Stock Products
    if (ooStock.classList.contains(classes.hide)) {
        ooStock.classList.remove(classes.hide)
    }

    // Show - Hide OOS Buttons
    hideOosStockButtons.forEach(button => {
        const parent = button.parentElement
        if (parent.classList.contains(classes.hide)) {
            parent.classList.remove(classes.hide)
        }
    });

    // Show active OOS filters
    activeOosFilters.forEach(filter => {
        const parent = filter.parentElement
        if (parent.classList.contains(classes.hide)) {
            parent.classList.remove(classes.hide)
        }

        if (filter.classList.contains(classes.hide)) {
            filter.classList.remove(classes.hide)
        }
    });

    filterWrappers.forEach(wrapper => {
        if (wrapper.classList.contains(classes.hide)) {
            wrapper.classList.remove(classes.hide)
        }
    });
   
    // Show OOS Filter Counts and Hide Vendor Counts
    defaultFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide) === false) {
            count.classList.add(classes.hide)
        }
    });

    oosFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide)) {
            count.classList.remove(classes.hide)
        }
    });
}

const hideOutOfstockProductFilters = () => {
    // Show Default Products
    if (defaultStock.classList.contains(classes.hide)) {
        defaultStock.classList.remove(classes.hide)
    }

    // Show - Show OOS Buttons
    showOosStockButtons.forEach(button => {
        const parent = button.parentElement
        if (parent.classList.contains(classes.hide)) {
            parent.classList.remove(classes.hide)
        }
    });

    // Hide OOS Stock Products
    if (ooStock.classList.contains(classes.hide) === false) {
        ooStock.classList.add(classes.hide)
    }

    // Hide - Hide OOS Buttons
    hideOosStockButtons.forEach(button => {
        const parent = button.parentElement
        if (parent.classList.contains(classes.hide) === false) {
            parent.classList.add(classes.hide)
        }
    });

    // Hide active OOS filters
    activeOosFilters.forEach(filter => {
        const parent = filter.parentElement
        if (parent.classList.contains(classes.hide) === false) {
            parent.classList.add(classes.hide)
        }

        if (filter.classList.contains(classes.hide) === false) {
            filter.classList.add(classes.hide)
        }
    });

    filterWrappers.forEach(wrapper => {
        if (wrapper.classList.contains(classes.hide) === false) {
            wrapper.classList.add(classes.hide)
        }
    });

    // Hide OOS Filter Counts and Show Vendor Counts
    defaultFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide)) {
            count.classList.remove(classes.hide)
        }
    });

    oosFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide) === false) {
            count.classList.add(classes.hide)
        }
    });
}

// Show default products and make filter buttons active
const showDefaultProductsButtonsFilters = () => {
    // Hide In Stock Products
    if (inStock.classList.contains(classes.hide) === false) {
        inStock.classList.add(classes.hide)
    }

    // Hide OOS Stock Products
    if (ooStock.classList.contains(classes.hide) === false) {
        ooStock.classList.add(classes.hide)
    }

    // Show Default Products
    if (defaultStock.classList.contains(classes.hide)) {
        defaultStock.classList.remove(classes.hide)
    }

    // Hide - Show OOS Buttons
    showOosStockButtons.forEach(button => {
        const parent = button.parentElement
        if (parent.classList.contains(classes.hide) === false) {
            parent.classList.add(classes.hide)
        }
    });

    // Show - Hide OOS Buttons
    hideOosStockButtons.forEach(button => {
        const parent = button.parentElement
        if (parent.classList.contains(classes.hide)) {
            parent.classList.remove(classes.hide)
        }
    });

    // Hide - Show InStock Buttons
    showInStockButtons.forEach(button => {
        const parent = button.parentElement
        if (parent.classList.contains(classes.hide) === false) {
            parent.classList.add(classes.hide)
        }
    });

    // Show - Hide InStock Buttons
    hideInStockButtons.forEach(button => {
        const parent = button.parentElement
        if (parent.classList.contains(classes.hide)) {
            parent.classList.remove(classes.hide)
        }
    });

    // Show active filters
    activeInStockFilters.forEach(filter => {
        const parent = filter.parentElement
        if (parent.classList.contains(classes.hide)) {
            parent.classList.remove(classes.hide)
        }

        if (filter.classList.contains(classes.hide)) {
            filter.classList.remove(classes.hide)
        }
    });

    activeOosFilters.forEach(filter => {
        const parent = filter.parentElement
        if (parent.classList.contains(classes.hide)) {
            parent.classList.remove(classes.hide)
        }

        if (filter.classList.contains(classes.hide)) {
            filter.classList.remove(classes.hide)
        }
    });

    filterWrappers.forEach(wrapper => {
        if (wrapper.classList.contains(classes.hide)) {
            wrapper.classList.remove(classes.hide)
        }
    });

    // Show Default Vendor Filter Counts, Hide OOS Counts and InStock Counts
    defaultFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide)) {
            count.classList.remove(classes.hide)
        }
    });

    instockFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide) === false) {
            count.classList.add(classes.hide)
        }
    });

    oosFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide) === false) {
            count.classList.add(classes.hide)
        }
    });
} 

// Hide instock and default products. Show OOS products.
const hideInStockDefShowOos = () => {
    // Hide Default Products
    if (defaultStock.classList.contains(classes.hide) === false) {
        defaultStock.classList.add(classes.hide)
    }

    // Hide In Stock Products
    if (inStock.classList.contains(classes.hide) === false) {
        inStock.classList.add(classes.hide)
    }

    // Show OOS Stock Products
    if (ooStock.classList.contains(classes.hide)) {
        ooStock.classList.remove(classes.hide)
    }

    // Show - Show InStock Buttons
    showInStockButtons.forEach(button => {
        const parent = button.parentElement
        if (parent.classList.contains(classes.hide)) {
            parent.classList.remove(classes.hide)
        }
    });

    // Hide - Hide InStock Buttons
    hideInStockButtons.forEach(button => {
        const parent = button.parentElement
        if (parent.classList.contains(classes.hide) === false) {
            parent.classList.add(classes.hide)
        }
    });

    // Hide active OOS filters
    // Do not hide the parent wrapper
    activeInStockFilters.forEach(filter => {
        if (filter.classList.contains(classes.hide) === false) {
            filter.classList.add(classes.hide)
        }
    });

    // Show OOS Filter Counts, Hide Vendor Counts and InStock Counts
    defaultFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide) === false) {
            count.classList.add(classes.hide)
        }
    });

    instockFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide) === false) {
            count.classList.add(classes.hide)
        }
    });

    oosFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide)) {
            count.classList.remove(classes.hide)
        }
    });
}

// Hide oos and default products. Show InStock products.
const hideOosDefShowInStock = () => {
    // Hide Default Products
    if (defaultStock.classList.contains(classes.hide) === false) {
        defaultStock.classList.add(classes.hide)
    }

    // Hide OOS Stock Products
    if (ooStock.classList.contains(classes.hide) === false) {
        ooStock.classList.add(classes.hide)
    }

    // Show In Stock Products
    if (inStock.classList.contains(classes.hide)) {
        inStock.classList.remove(classes.hide)
    }

    // Show - Show OOS Buttons
    showOosStockButtons.forEach(button => {
        const parent = button.parentElement
        if (parent.classList.contains(classes.hide)) {
            parent.classList.remove(classes.hide)
        }
    });

    // Hide - Hide OOS Buttons
    hideOosStockButtons.forEach(button => {
        const parent = button.parentElement
        if (parent.classList.contains(classes.hide) === false) {
            parent.classList.add(classes.hide)
        }
    });

    // Hide active OOS filters
    // Do not hide the parent wrapper
    activeOosFilters.forEach(filter => {
        if (filter.classList.contains(classes.hide) === false) {
            filter.classList.add(classes.hide)
        }
    });

    // Show OOS Filter Counts, Hide Vendor Counts and InStock Counts
    defaultFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide) === false) {
            count.classList.add(classes.hide)
        }
    });

    instockFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide)) {
            count.classList.remove(classes.hide)
        }
    });

    oosFilterCounts.forEach(count => {
        if (count.classList.contains(classes.hide) === false) {
            count.classList.add(classes.hide)
        }
    });
}

// Initialization

// Click Event
document.addEventListener('click', e => {
    // Show In Stock Products and Related Filter
    if (e.target.closest(selectors.btnInStockShow)) {

        clickedFilters.push(inStockTag)
        setCookie(inStockCookie, "yes", 30)

        if (clickedFilters.length === 1) {
            showInStockProductsFilters()
        } else {
            showDefaultProductsButtonsFilters()
        }
    }

    // Hide In Stock Products and Related Filter
    if (e.target.closest(selectors.btnInStockHide)) {
        const index = clickedFilters.indexOf(inStockTag);
        clickedFilters.splice(index, 1)

        deleteCookie(inStockCookie)


        if (clickedFilters.length === 0) {
            hideInstockProductFilters()
        } else {
            hideInStockDefShowOos()
        }
    }

    // Remove InStock Filter
    if (e.target.closest(selectors.activeInStockFilter)) {
        const index = clickedFilters.indexOf(inStockTag);
        clickedFilters.splice(index, 1)

        deleteCookie(inStockCookie)

        if (clickedFilters.length === 0) {
            hideInstockProductFilters()
        } else {
            hideInStockDefShowOos()
        }
    }

    // Show OOS Products and Related Filter
    if (e.target.closest(selectors.btnOosStockShow)) {

        clickedFilters.push(outOfStockTag)
        setCookie(oosStockCookie, "yes", 30)

        if (clickedFilters.length === 1) {
            showOutOfStockProductsFilters()
        } else {
            showDefaultProductsButtonsFilters()
        }
    }

    // Hide OOS Products and Related Filter
    if (e.target.closest(selectors.btnOosStockHide)) {
        const index = clickedFilters.indexOf(outOfStockTag);
        clickedFilters.splice(index, 1)

        deleteCookie(oosStockCookie)

        if (clickedFilters.length === 0) {
            hideOutOfstockProductFilters()
        } else {
            hideOosDefShowInStock()
        }        
    }

    // Remove OOS Filter
    if (e.target.closest(selectors.activeOosFilter)) {
        const index = clickedFilters.indexOf(outOfStockTag);
        clickedFilters.splice(index, 1)

        deleteCookie(oosStockCookie)

        if (clickedFilters.length === 0) {
            hideOutOfstockProductFilters()
        } else {
            hideOosDefShowInStock()
        }
    }
})

// Load Event
document.addEventListener("DOMContentLoaded", () => {
    // Check if InStock Cookie Exists and OOS Cookie does not exist
    // If it exists show instock products and activate filters
    if (getInStockCookie === 'yes' && getOosStockCookie !== 'yes') {
        showInStockProductsFilters()
        clickedFilters.push(inStockTag)
    }

    // Check if OOS Stock Cookie Exists and InStock Cookie does not exist
    // If it exists show oos products and activate filters
    if (getInStockCookie !== 'yes' && getOosStockCookie === 'yes') {
        showOutOfStockProductsFilters()
        clickedFilters.push(outOfStockTag)
    }

    // Check if OOS Stock Cookie and InStock Cookie exist
    // If they exist show default products and activate filters
    if (getInStockCookie === 'yes' && getOosStockCookie === 'yes') {
        showDefaultProductsButtonsFilters()
        clickedFilters.push(inStockTag, outOfStockTag)
    }
});

/***
 * 
 * Global Functions
 * 
 */
function getCollectionData() {
    return JSON.parse(document.querySelector(selectors.collectionJSON).innerHTML)
}

/***
 * 
 * Cookie Functions
 * 
 */

// Function to set a cookie that expire after 30 minutes
function setCookie(cname, cvalue, exminutes) {
    const d = new Date();
    d.setTime(d.getTime() + (exminutes * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// Function to get a cookie
function getCookie(cname) {
    const name = cname + "=";
    const ca = document.cookie.split(';');
    
    for (const c of ca) {
      let cookie = c.trim();
      if (cookie.startsWith(name)) {
        return cookie.substring(name.length);
      }
    }
    
    return "";
}

// Function to delete a cookie
function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}
  
/***
 * 
 * Pagination Settings
 * 
 */

// In Stock Pagination - Hide Settings
function hidePaginationInStock () {
    if (totalInStock < paginationNum) {
        if (pagination !== null && pagination.classList.contains(classes.hide) === false) {
            pagination.classList.add(classes.hide)
        }
    }
}

// OOS Pagination - Hide Settings
function hidePaginationOosStock() {
    if (totalOutOfStock < paginationNum) {
        if (pagination !== null && pagination.classList.contains(classes.hide) === false) {
            pagination.classList.add(classes.hide)
        }
    }
}

// Default Collection Products Pagination - Show Settings
function showPaginationDefProducts() {
    if (collectionNum > paginationNum) {
        if (pagination !== null && pagination.classList.contains(classes.hide)) {
            pagination.classList.remove(classes.hide)
        }
    }
}